import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBurgerDrink = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M14,15v-1c0,-1.657 -1.343,-3 -3,-3h-5c-1.657,0 -3,1.343 -3,3v1" }),
			/* @__PURE__ */ _jsx("path", { d: "M12,21h-7c-1.105,0 -2,-0.895 -2,-2v-1h11v1c0,1.105 -0.895,2 -2,2Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M2,15h13" }),
			/* @__PURE__ */ _jsx("path", { d: "M10.684,11l-0.381,-2.868c-0.079,-0.6 0.387,-1.132 0.992,-1.132h8.705c0.609,0 1.076,0.539 0.99,1.141l-1.714,12c-0.071,0.493 -0.493,0.859 -0.99,0.859h-2.133" }),
			/* @__PURE__ */ _jsx("path", { d: "M19.153,3h-2.137c-0.496,0 -0.916,0.363 -0.989,0.853l-0.468,3.147" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgBurgerDrink;
